<template>
  <span
    class="notification-level-badge inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-[3px] text-[10px] font-medium leading-none tracking-wide"
    :class="[done ? DONE_CLASSES : LEVEL_CLASSES[level], { 'opacity-60': read && !done }]"
    :data-level="level"
    :data-read="read ? 'true' : undefined"
    :data-done="done ? 'true' : undefined"
  >
    <span class="h-1 w-1 shrink-0 rounded-full bg-current" aria-hidden="true" />
    {{ done ? DONE_LABEL : LEVEL_LABELS[level] }}
  </span>
</template>

<script setup lang="ts">
/**
 * NOTIF-003 — the level chip (Readdy design, 2026-10-21): Action needed wears the D&D yellow
 * badge tokens, Heads-up the blue ones, Info the light-blue accent. A read Heads-up / Info keeps
 * its colour, dimmed. A read Action needed is done — an Action needed is read only by the
 * person's click (the download, the opened step) — so it turns into the green "Action done"
 * (owner, 2026-11-04), not dimmed.
 */
import { computed } from 'vue'
import type { NotificationLevel } from '@/services/notificationsApi'
import { LEVEL_LABELS } from '@/lib/notifications/pages'

const props = defineProps<{ level: NotificationLevel; read?: boolean }>()

const DONE_LABEL = 'Action done'
const DONE_CLASSES = 'bg-badge-green text-badge-green'

const done = computed(() => props.level === 'action_needed' && props.read === true)

const LEVEL_CLASSES: Record<NotificationLevel, string> = {
  action_needed: 'bg-badge-yellow text-badge-yellow',
  heads_up: 'bg-badge-blue text-badge-blue',
  info: 'bg-badge-sky text-badge-sky'
}
</script>

<style scoped>
.notification-level-badge {
  border-color: color-mix(in oklab, currentColor 40%, transparent);
}
</style>
